import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reduxPromise from 'redux-promise';
import rootReducer from './modules';
import { setStore } from './modules/getStore';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk, reduxPromise)));

setStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js